import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const baseRoute = `${code}.${work.key}_`;
const codeAPI = apiConstants.codeAPI;
const group = work.basePath;

export const type = work.key;
export const panels = {
    municipal_interventions_home: {
        menu: {
            route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.${work.basePath}.home`,
            text: "home.title_map",
            icon: "fas fa-map-marked",
        },
        acl: {
            view: "GIM_24000",
        },
    },
    home_municipal_interventions: {
        menu: {
            route: `${code}.${group}.home`,
            text: "municipal_interventions_home.title",
            icon: "fas fa-building",
        },
        acl: {
            view: "GIM_24000",
        },
    },
    municipal_interventions_statuses: {
        menu: {
            route: `${baseRoute}statuses`,
            text: "municipal_interventions_statuses.titles",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_24031",
            detail: "GIM_24032",
            add: "GIM_24033",
            edit: "GIM_24034",
            delete: "GIM_24035",
        },
        url: {
            getList: `${codeAPI}/${group}/status`,
            getShow: `${codeAPI}/${group}/status/:id`,
            getCreate: `${codeAPI}/${group}/status`,
            getUpdate: `${codeAPI}/${group}/status/:id`,
            getDelete: `${codeAPI}/${group}/status/:id`,
        },
    },
    municipal_interventions_types: {
        menu: {
            route: `${baseRoute}types`,
            text: "municipal_interventions_types.titles",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_24041",
            detail: "GIM_24042",
            add: "GIM_24043",
            edit: "GIM_24044",
            delete: "GIM_24045",
        },
        url: {
            getList: `${codeAPI}/${group}/type`,
            getShow: `${codeAPI}/${group}/type/:id`,
            getCreate: `${codeAPI}/${group}/type`,
            getUpdate: `${codeAPI}/${group}/type/:id`,
            getDelete: `${codeAPI}/${group}/type/:id`,
        },
    },
    municipal_interventions_service_typologies: {
        menu: {
            route: `${baseRoute}service_typologies`,
            text: "municipal_interventions_service_typologies.titles",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_24051",
            detail: "GIM_24052",
            add: "GIM_24053",
            edit: "GIM_24054",
            delete: "GIM_24055",
        },
        url: {
            getList: `${codeAPI}/${group}/service_typology`,
            getShow: `${codeAPI}/${group}/service_typology/:id`,
            getCreate: `${codeAPI}/${group}/service_typology`,
            getUpdate: `${codeAPI}/${group}/service_typology/:id`,
            getDelete: `${codeAPI}/${group}/service_typology/:id`,
        },
    },
    municipal_interventions_unities: {
        menu: {
            route: `${baseRoute}unities`,
            text: "municipal_interventions_unities.titles",
            icon: "fas fa-users",
        },
        acl: {
            view: "GIM_24061",
            detail: "GIM_24062",
            add: "GIM_24063",
            edit: "GIM_24064",
            delete: "GIM_24065",
        },
        url: {
            getList: `${codeAPI}/${group}/unity`,
            getShow: `${codeAPI}/${group}/unity/:id`,
            getCreate: `${codeAPI}/${group}/unity`,
            getUpdate: `${codeAPI}/${group}/unity/:id`,
            getDelete: `${codeAPI}/${group}/unity/:id`,
            getLists: `${codeAPI}/${group}/unity/lists`,
            getUsers: `${codeAPI}/${group}/unity/search/user?id=:id&q=:query`,
        },
    },
    municipal_interventions_reports: {
        menu: {
            route: `${baseRoute}reports`,
            text: 'municipal_interventions_reports.titles',
            icon: 'fas fa-tasks',
        },
        acl: {
            view                    : 'GIM_24073',
            detail                  : 'GIM_24074',
            add                     : 'GIM_24075',
            edit                    : 'GIM_24076',
            delete                  : 'GIM_24077',
            config                  : 'GIM_24071',
            configEdit              : 'GIM_24072',
        },
        url: {
            getList                 : `${codeAPI}/${group}/report`,
            getShow                 : `${codeAPI}/${group}/report/:id`,
            getCreate               : `${codeAPI}/${group}/report`,
            getUpdate               : `${codeAPI}/${group}/report/:id`,
            getDelete               : `${codeAPI}/${group}/report/:id`,
            getConfig               : `${codeAPI}/${group}/report/settings`,
            getScales               : `${codeAPI}/${group}/report/scales`,
            getApps                 : `${codeAPI}/${group}/report/print/apps`,
            getLayouts              : `${codeAPI}/${group}/report/print/layouts/:appid`,
            getFormats              : `${codeAPI}/${group}/report/print/formats/:appid`,
            getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
        },
    },
    municipal_interventions_global_types: {
        menu: {
            route: `${baseRoute}global_types`,
            text: "global_types.titles",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_24021",
            detail: "GIM_24022",
            add: "GIM_24023",
            edit: "GIM_24024",
            delete: "GIM_24025",
        },
        url: {
            getList: `${codeAPI}/gestao/${group}/type`,
            getShow: `${codeAPI}/gestao/${group}/type/:id`,
            getCreate: `${codeAPI}/gestao/${group}/type`,
            getUpdate: `${codeAPI}/gestao/${group}/type/:id`,
            getDelete: `${codeAPI}/gestao/${group}/type/:id`,
            getRelationship: `${codeAPI}/:code/type`,
            getEntities: `${codeAPI}/gestao/entities`,
        },
    },
    municipal_interventions_global_statuses: {
        menu: {
            route: `${baseRoute}global_statuses`,
            text: "global_statuses.titles",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_24011",
            detail: "GIM_24012",
            add: "GIM_24013",
            edit: "GIM_24014",
            delete: "GIM_24015",
        },
        url: {
            getList: `${codeAPI}/gestao/${group}/status`,
            getShow: `${codeAPI}/gestao/${group}/status/:id`,
            getCreate: `${codeAPI}/gestao/${group}/status`,
            getUpdate: `${codeAPI}/gestao/${group}/status/:id`,
            getDelete: `${codeAPI}/gestao/${group}/status/:id`,
            getRelationship: `${codeAPI}/:code/status`,
            getEntities: `${codeAPI}/gestao/entities`,
        },
    },
};
